import { usePreviewSubscription } from '@root/lib/sanity';
import { Page } from '../../../sanity/sanity.types';
import SanityPage from './SanityPage';
import { SanityPageProps } from './withSanityPageProps';
import { PortableText, Serializers, SerializerContext } from './serializers';

export type PageBuilderProps = SanityPageProps & {
  serializers?: Serializers;
};

/**
 * Represents a Sanity backed page that makes use of the PortableText based page
 * builder functionality
 */
export default function PageBuilder({ data, preview, serializers }: PageBuilderProps) {
  const { data: pageData } = usePreviewSubscription<Page>(data?.query, {
    params: data?.queryParams ?? {},
    initialData: data?.page,
    enabled: preview,
  });

  const serializerOptions = {
    serializers,
    data: data.static,
  };

  return (
    <SanityPage data={data} preview={preview}>
      <SerializerContext.Provider value={serializerOptions}>
        <PortableText content={pageData.pageBuilder ?? []} />
      </SerializerContext.Provider>
    </SanityPage>
  );
}
